import { reatomAsync, withDataAtom } from "@reatom/async";
import { ChangePasswordDto } from "definitions/poizon-sso";
import { API } from "src/api";
import { AppRouter } from "src/App";
import { withIsLoadingAtom } from "src/common/pipes";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { toastHandler } from "src/util";

export const resetPasswordRequest = reatomAsync(
  (_ctx, dto: ChangePasswordDto) => {
    return API.authApi.authControllerChangePassword(dto);
  },
  "resetPasswordRequest",
).pipe(withDataAtom(null), withIsLoadingAtom());

resetPasswordRequest.onFulfill.onCall(() => {
  AppRouter.navigate(RoutesPaths.AUTH.LOGIN, { replace: true });
  toastHandler.success({
    name: "restoreSended",
    title: "Пароль изменен",
    content: "Войдите в свою учетную запись",
  });
});
